import { request } from './client';

export interface Version {
  id: string;
  versionNumber: number;
  note: string | null;
  sizeBytes: number;
  createdBy: string;
  createdByNickname: string | null;
  createdAt: string;
}

export const versionsApi = {
  list: (docId: string) => request<Version[]>(`/docs/${docId}/versions`),

  create: (docId: string, data: { note?: string }) =>
    request<Version>(`/docs/${docId}/versions`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  restore: (docId: string, versionId: string) =>
    request<{ ok: boolean; restored: boolean }>(`/docs/${docId}/versions/${versionId}/restore`, {
      method: 'POST',
    }),
};
